import { Box, Stack } from '@mui/material';
import { Route, type RouteProps } from 'react-router-dom';

import { Text, Title, isDefined, useAuthContext, useLoggedInAuthContext } from 'common';

import { type PermissionRequirement, type RoleRequirement } from './types';
import { isPermissionAuthorized, isRoleAuthorized } from './utils';

type ProtectedRouteProps = RouteProps &
  (
    | { permissionRequirement: PermissionRequirement; roleRequirement?: RoleRequirement }
    | { roleRequirement: RoleRequirement; permissionRequirement?: PermissionRequirement }
  );

export function ProtectedRoute(props: ProtectedRouteProps) {
  const { permissionRequirement, roleRequirement } = props;
  const { permissions } = useAuthContext();
  const { user } = useLoggedInAuthContext();

  const permissionAuthorized =
    !isDefined(permissionRequirement) || isPermissionAuthorized(permissions, permissionRequirement);

  const roleAuthorized =
    !isDefined(roleRequirement) || isRoleAuthorized(user.role, roleRequirement);

  if (!(permissionAuthorized && roleAuthorized)) {
    return (
      <Box
        sx={{
          paddingX: 4,
          paddingY: 2,
        }}
      >
        <Stack spacing={2}>
          <Title component="h1" variant="heading2" bold>
            Access Denied
          </Title>
          <Text variant="body1">You are not authorized to access this page.</Text>
        </Stack>
      </Box>
    );
  }
  return <Route {...props} />;
}
